import { render, staticRenderFns } from "./widgetControl.vue?vue&type=template&id=6a08d3c7&"
import script from "./widgetControl.vue?vue&type=script&lang=ts&"
export * from "./widgetControl.vue?vue&type=script&lang=ts&"
import style0 from "./widgetControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports